import { noop } from 'ts-essentials';

const windowMatchMediaMock = () => ({
  matches: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  addEventListener: noop,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  removeEventListener: noop,
});

const isBrowserRuntime = typeof window !== 'undefined';

if (isBrowserRuntime) {
  window.matchMedia = window.matchMedia || windowMatchMediaMock;
}

export const ssrSafeWindow = isBrowserRuntime
  ? window
  : {
      matchMedia: windowMatchMediaMock,
    };
